import styles from './TopBar.module.scss'

const TopBar = ({ children }) => (
  <div className={styles.bar}>
    <div className={styles.container}>{children}</div>
  </div>
)

export default TopBar
